export default theme => ({
  focusedBorder: {
    '&:focus': {
      border: 'unset',
      borderBottom: '1px solid rgb(224, 224, 224) !important'
    }
  },
  emptyCell: {
    color: theme.palette.text.secondary
  }
});
